import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
// import Layout from '@/layout'
import Layout from '@/common/layout/Index'
// import { mapGetters} from "vuex";
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/Index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/',
    children: [{
      path: '/',
      name: 'Dashboard',
      component: () => import('@/views/home/Index'),
      // meta: { title: '首页', icon: 'dashboard' }
      meta: {title: '首页', icon: 'home-nav'}
    }]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/error-page/Redirect')
      }
    ]
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/upload/excel',
        component: () => import('@/components/upload/UploadExcel'),
        name: 'Icons',
        meta: {title: '导入数据', icon: 'icon'}
      }
    ]
  }
]
export const localRoutes = [
  {
    path: '/localRoute',
    // alwaysShow: true, // will always show the root menu
    name: 'localRoute',
    meta: {title: '', breadcrumb: false},
    component: Layout,
    children: [
      {
        path: '/recipe/detail',
        component: () => import('@/views/recipe/Detail'),
        name: 'RecipeDetail',
        meta: {
          title: '处方详情',
          parentPath: ['/recipe/recipeList', '/recipe/recipeDispense', '/recipe/recipeDecoct', '/recipe/recipePost']
        },
        hidden: true
      },
      {
        path: '/medicine/priceDetail',
        name: 'PriceDetail',
        component: () => import('@/views/medicine/PriceDetail'),
        hidden: true,
        meta: {title: '调价单详情', pPath: '/medicine/price'}
      },
      {
        path: '/inventory/incomingDetail',
        name: 'IncomingDetail',
        component: () => import('@/views/stock/inStock/IncomingDetail'),
        hidden: true,
        meta: {title: '入库详情', pPath: '/stock/inStock'}
      },
      {
        path: '/inventory/outDetail',
        name: 'OutDetail',
        component: () => import('@/views/stock/outStock/OutDetail'),
        hidden: true,
        meta: {title: '出库详情', pPath: '/stock/outStock'}
      },
      {
        path: '/allocate/inAllocate',
        name: 'inAllocate',
        component: () => import('@/views/stock/allocate/inAllocate'),
        hidden: true,
        meta: {title: '调拨入库单明细', pPath: '/stock/allocate'}
      },
      {
        path: '/allocate/outAllocate',
        name: 'outAllocate',
        component: () => import('@/views/stock/allocate/outAllocate'),
        hidden: true,
        meta: {title: '调拨出库单明细', pPath: '/stock/allocate'}
      },
      {
        path: '/inventory/checkDetail',
        name: 'CheckDetail',
        component: () => import('@/views/stock/inventoryStock/CheckDetail'),
        hidden: true,
        meta: {title: '盘点详情',}
      },
      {
        path: '/inventory/lossDetail',
        name: 'LossDetail',
        component: () => import('@/views/stock/lossStock/LossDetail'),
        hidden: true,
        meta: {title: '报损详情', pPath: '/inventory/lossList'}
      },
      {
        path: '/inDrug/IndrugDetail',
        name: 'IndrugDetail',
        component: () => import('@/views/drugepot/inDrug/IndrugDetail'),
        hidden: true,
        meta: {title: '入库详情', pPath: '/drugepot/inDrug'}
      },
      {
        path: '/outDrug/OutdrugDetail',
        name: 'OutdrugDetail',
        component: () => import('@/views/drugepot/outDrug/OutdrugDetail'),
        hidden: true,
        meta: {title: '出库详情', pPath: '/drugepot/outDrug'}
      },
      {
        path: '/drugAllocate/druginAllocate',
        name: 'druginAllocate',
        component: () => import('@/views/drugepot/drugAllocate/druginAllocate'),
        hidden: true,
        meta: {title: '调拨入库单明细', pPath: '/drugepot/drugAllocate'}
      },
      {
        path: '/drugAllocate/drugoutAllocate',
        name: 'drugoutAllocate',
        component: () => import('@/views/drugepot/drugAllocate/drugoutAllocate'),
        hidden: true,
        meta: {title: '调拨出库单明细', pPath: '/drugepot/drugAllocate'}
      },
      {
        path: '/drugInventory/drugcheckDetail',
        name: 'drugcheckDetail',
        component: () => import('@/views/drugepot/drugInventory/drugcheckDetail'),
        hidden: true,
        meta: {title: '盘点详情',}
      },
      {
        path: '/drugInventory/drugcheckInventory', ///inventory/checkInventory
        name: 'drugcheckInventory',
        hidden: true,
        component: () => import('@/views/drugepot/drugInventory/drugcheckInventory'),
        meta: {title: '盘点库存', icon: 'icon'}
      },
      {
        path: '/frmLoss/frmlossDetail',
        name: 'frmlossDetail',
        component: () => import('@/views/drugepot/frmLoss/frmlossDetail'),
        hidden: true,
        meta: {title: '报损详情', pPath: '/frmLoss/frmlossDetail'}
      },
      {
        path: '/returned/returnedDetail',
        name: 'returnedDetail',
        component: () => import('@/views/drugepot/returned/returnedDetail'),
        hidden: true,
        meta: {title: '退货详情', pPath: '/returned/returnedDetail'}
      },
      {
        path: '/setting/permissionSetting',
        component: () => import('@/views/system/role/PermissionSetting'),
        name: '/setting/PermissionSetting',
        hidden: true,
        meta: {title: '职务权限', pPath: '/system/role', icon: 'icon'}
      },
      {
        path: '/setting/setPharmacy',
        component: () => import('@/views/system/store/SetPharmacy'),
        name: 'settingSetPharmacy',
        hidden: true,
        meta: {title: '药房设置', pPath: '/system/store', icon: 'icon'}
      },
      {
        path: '/inventory/checkInventory', ///inventory/checkInventory
        name: 'CheckInventory',
        hidden: true,
        component: () => import('@/views/stock/inventoryStock/CheckInventory'),
        meta: {title: '盘点库存', icon: 'icon'}
      },
      {
        path: '/report/orgMediDetails',
        component: () => import('@/views/report/sales/SalesDetail'),
        hidden: true,
        name: 'orgMediDetails',
        meta: {title: '销售明细表', icon: 'icon'}
      },
      {
        path: '/report/docPrescribing',
        name: 'docPrescribing',
        hidden: true,
        meta: {title: '机构绩效汇总表', icon: 'icon'},
        component: () => import('@/views/report/operate/DocPrescribing'),
      },
      {
        path: '/report/docDetails',
        name: 'docDetails',
        hidden: true,
        meta: {title: '医生绩效明细表', icon: 'icon'},
        component: () => import('@/views/report/operate/DocDetails'),
      },
    ]
  },
]

export const page404 = [
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    name: 'ErrorPages',
    hidden: true,
    meta: {
      title: 'Error Pages',
      icon: '404'
    }, children: [{
      path: '/error/401',
      component: () => import('@/views/error-page/401'),
      name: 'Page401',
      meta: {title: '401', noCache: true}
    }, {
      path: '/error/404',
      component: () => import('@/views/error-page/404'),
      name: 'Page404',
      meta: {title: '404', noCache: true}
    }]
  },
  {path: '*', redirect: '/error/404', hidden: true}
]
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/Index'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/',
    children: [{
      path: '/',
      name: 'Dashboards',
      component: () => import('@/views/home/Index'),
      meta: {title: '首页', icon: 'home-nav'}
    }]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/error-page/Redirect')
      }
    ]
  },
  // {
  //   path: '/medicines',
  //   // alwaysShow: true, // will always show the root menu
  //   name: 'Medicine',
  //   redirect: '/medicine',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '/medicine', // /medicine/index
  //       component: () => import('@/views/medicine/Index'),
  //       name: 'Medicines',
  //       meta: { title: '药材管理'}
  //     }
  //   ]
  // },
  {
    path: '/medicines',
    // alwaysShow: true, // will always show the root menu
    name: 'Medicine',
    meta: {title: '药材管理', breadcrumb: false},
    component: Layout,
    children: [
      {
        path: '/medicine',
        component: () => import('@/views/medicine/Index'),
        name: 'Medicines',
        meta: {title: '药房库存管理', icon: 'icon'}
      },
      {
        path: '/ykIndex', // /inventory/incomingList
        component: () => import('@/views/medicine/ykIndex'),
        name: 'ykIndex',
        meta: {title: '药库库存管理', icon: 'icon'}
      },
      // {
      //   path: '/medicine/medicineMap',
      //   component: () => import('@/views/medicine/Gf'),
      //   name: 'MedicineGf',
      //   meta: {title: '古方对照', icon: 'icon'}
      // },
      // {
      //   path: '/medicine/gfDict',
      //   component: () => import('@/views/medicine/GfDict'),
      //   name: 'MedicineGfDict',
      //   meta: {title: '古方对照字典', icon: 'icon'}
      // },
      // {
      //   path: '/medicine/price',
      //   component: () => import('@/views/medicine/MedicinePrice'),
      //   name: 'MedicinePrice',
      //   meta: {title: '药材调价', icon: 'icon'}
      // },
    ]
  },

  {
    path: '/recipe',
    // alwaysShow: true, // will always show the root menu
    name: 'Recipe',
    meta: {title: '处方管理', breadcrumb: false},
    component: Layout,
    children: [
      {
        path: '/recipe/RecipeAudit',
        component: () => import('@/views/recipe/RecipeAudit'),
        name: 'recipeAudit',
        meta: {title: '处方审核', icon: 'icon'}
      },
      {
        path: '/recipe/recipeList',// /recipe/index
        component: () => import('@/views/recipe/RecipeList'),
        name: 'RecipeIndex',
        meta: {title: '处方列表', icon: 'icon'}
      },
      {
        path: '/recipe/recipeDispense', // /recipe/dispense
        component: () => import('@/views/recipe/RecipeDispense'),
        name: 'RecipeDispense',
        meta: {title: '配药列表', icon: 'icon'}
      },
      {
        path: '/recipe/recipeDecoct',  // /recipe/decoct
        component: () => import('@/views/recipe/RecipeDecoct'),
        name: 'RecipeDecoct',
        meta: {title: '代煎列表', icon: 'icon'}
      }, {
        path: '/recipe/recipePost', // /recipe/post
        component: () => import('@/views/recipe/RecipePost'),
        name: 'RecipePost',
        meta: {title: '发药列表', icon: 'icon'}
      }
    ]
  },
  {
    path: '/stock',
    // alwaysShow: true, // will always show the root menu
    name: 'stockList',
    meta: {title: '药房管理', icon: 'documentation'},
    component: Layout,
    children: [
      {
        path: '/stock/inStock', // /inventory/incomingList
        component: () => import('@/views/stock/inStock/IncomingList'),
        name: 'IncomingList',
        meta: {title: '入库管理', icon: 'icon'}
      },
      {
        path: '/stock/outStock', // /inventory/outList
        name: 'OutList',
        component: () => import('@/views/stock/outStock/OutList'),
        meta: {title: '出库管理', icon: 'icon'}
      },
      // {
      //   path: '/stock/allocate', // /inventory/outList
      //   name: 'OutList',
      //   component: () => import('@/views/stock/allocate/allocateList'),
      //   meta: {title: '库存调拨', icon: 'icon'}
      // },
      {
        path: '/stock/inventory',
        name: 'CheckList',
        component: () => import('@/views/stock/inventoryStock/CheckList'),
        meta: {title: '盘点列表', icon: 'icon'}
      },
      {
        path: '/stock/lose', //   /inventory/lossList
        name: 'LossList',
        component: () => import('@/views/stock/lossStock/LossList'),
        meta: {title: '库存报损', icon: 'icon'}
      }
    ]
  },
  {
    path: '/drugepot',
    // alwaysShow: true, // will always show the root menu
    name: 'drugepot',
    meta: {title: '药库管理', icon: 'documentation'},
    component: Layout,
    children: [
      {
        path: '/drugepot/inDrug', // /inventory/incomingList
        component: () => import('@/views/drugepot/inDrug/IndrugList'),
        name: 'Drugepot',
        meta: {title: '入库管理', icon: 'icon'}
      },
      {
        path: '/drugepot/outDrug', // /inventory/incomingList
        component: () => import('@/views/drugepot/outDrug/OutdrugList'),
        name: 'Drugepot',
        meta: {title: '出库管理', icon: 'icon'}
      },
      {
        path: '/drugepot/drugAllocate', // /inventory/incomingList
        component: () => import('@/views/drugepot/drugAllocate/drugallocateList'),
        name: 'Drugepot',
        meta: {title: '库存调拨', icon: 'icon'}
      },
      {
        path: '/drugepot/drugInventory', // /inventory/incomingList
        component: () => import('@/views/drugepot/drugInventory/drugcheckList'),
        name: 'Drugepot',
        meta: {title: '盘点列表', icon: 'icon'}
      },
      {
        path: '/drugepot/frmLoss', // /inventory/incomingList
        component: () => import('@/views/drugepot/frmLoss/frmlossList'),
        name: 'Drugepot',
        meta: {title: '库存报损', icon: 'icon'}
      },
      {
        path: '/drugepot/returned', // /inventory/incomingList
        component: () => import('@/views/drugepot/returned/returnedList'),
        name: 'Drugepot',
        meta: {title: '退货管理', icon: 'icon'}
      }
    ]
  },
  {
    path: '/report',
    // alwaysShow: true, // will always show the root menu
    name: 'Report',
    meta: {title: '药房报表', icon: 'documentation'},
    component: Layout,
    children: [
      {
        // path: '/report/wholeOperation',
        path: '/report/operating',
        name: 'wholeOperation',
        meta: {title: '整体运营一览表', icon: 'icon'},
        component: () => import('@/views/report/operate/Index'),
      },
      {
        // path: '/report/mediDetails',
        path: '/report/medicine',
        component: () => import('@/views/report/sales/SalesSum'),
        name: 'mediDetails',
        // meta: {title: '销售汇总表', icon: 'icon'}
        meta: {title: '药品销售一览表', icon: 'icon'}
      },
      {
        path: '/report/phaSales',
        name: 'phaSales',
        meta: {title: '药房销售汇总表', icon: 'icon'},
        component: () => import('@/views/report/medicineSale/Index'),
      },
      // {
      //   path: '/report/financialSum',
      //   name: 'financialSum',
      //   meta: {title: '财务汇总报表', icon: 'icon'},
      //   component: () => import('@/views/report/finance/Index'),
      // }
    ]
  },
  {
    path: '/drugReport',
    // alwaysShow: true, // will always show the root menu
    name: 'DrugReport',
    meta: {title: '药库报表', icon: 'documentation'},
    component: Layout,
    children: [
      {
        path: '/drugReport/pharmacist',
        name: 'pharmacist',
        meta: {title: '药剂师工作量统计报表', icon: 'icon'},
        component: () => import('@/views/drugReport/pharmacist/Index'),
      },
      {
        path: '/drugReport/purchase',
        name: 'purchase',
        meta: {title: '药品购入统计汇总', icon: 'icon'},
        component: () => import('@/views/drugReport/purchase/Index'),
      },
      {
        path: '/drugReport/drugput',
        name: 'purchase',
        meta: {title: '药品购买入库明细表', icon: 'icon'},
        component: () => import('@/views/drugReport/drugput/Index'),
      },
      {
        path: '/drugReport/outbound',
        name: 'purchase',
        meta: {title: '药品出库汇总表', icon: 'icon'},
        component: () => import('@/views/drugReport/outbound/Index'),
      }
    ]
  },
  {
    path: '/system',
    // alwaysShow: true, // will always show the root menu
    name: 'RoleManagement',
    meta: {title: '系统设置', icon: 'settings'},
    component: Layout,
    children: [
      {
        path: '/system/store', // /setting/index
        component: () => import('@/views/system/store/Index'),
        name: 'settingIndex',
        meta: {title: '药房管理', icon: 'icon'}
      },
      {
        path: '/system/role', // /setting/roleManagement
        component: () => import('@/views/system/role/Index'),
        name: 'settingRoleManagement',
        meta: {title: '角色管理', icon: 'icon'}
      },
      {
        path: '/system/user', // /setting/staffManagement
        component: () => import('@/views/system/user/Index'),
        name: 'StaffManagement',
        meta: {title: '员工管理', icon: 'icon'}
      },
      {
        path: '/system/supplier',  // /setting/supManagement
        name: 'SupManagement',
        component: () => import('@/views/system/supplier/Index'),
        meta: {title: '供应商管理', icon: 'icon'}
      }
    ]
  },
  {
    path: '/upload',
    // alwaysShow: true, // will always show the root menu
    name: 'Upload',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/upload/excel',
        component: () => import('@/components/upload/UploadExcel'),
        name: 'Icons',
        meta: {title: '导入数据', icon: 'icon'}
      }
    ]
  }
]
export const asyncRoutes = []
const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  // routes: constantRoutes
  routes: constRoutes
})
const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
